export default "__VITE_ASSET__DPsmL$lj__"